import { render, staticRenderFns } from "./OrdinaryMsg.vue?vue&type=template&id=64c16571&scoped=true"
import script from "./OrdinaryMsg.vue?vue&type=script&lang=js"
export * from "./OrdinaryMsg.vue?vue&type=script&lang=js"
import style0 from "./OrdinaryMsg.vue?vue&type=style&index=0&id=64c16571&prod&rel=stylesheet%2Fscss&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c16571",
  null
  
)

export default component.exports